<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card outlined class="ma-0" :max-width="1100">
          <div class="scroll" align="left" v-if="view">
            <canvas
              id="canvassample"
              class="canvas"
              :width="width"
              :height="height"
              @mousedown="MouseDown"
              @mouseup="MouseUp"
              @mousemove="MouseMove"
            ></canvas>
          </div>
        </v-card>
      </v-col>
      <v-col><v-btn @click="del" class="ma-2"> 右下データ削除</v-btn></v-col>
      <v-col><v-btn @click="takeover" class="ma-2"> 右下ID引継ぎ</v-btn></v-col>
      <div align="right">
        <v-btn @click="formCopyRow" class="ma-2">
          最終行を複製
        </v-btn>
      </div>
      <!--
      <v-col>
        <v-btn @click="formCopy" class="ma-2" >
          左下フォームを右下にコピー
        </v-btn>
      </v-col>
      -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    area_temp: Array,
    r: Number,
    c: Number,
  },
  components: {},
  data() {
    let a_width = 25; //左端項番
    let r = this.r; //3;//行数
    let c = this.c; //7;//列数
    let b_width = 200; //1行の幅
    let b_height = 50; //1列の幅
    //
    return {
      //左端項番の幅
      a_width: a_width,
      //
      view: true,
      //
      radius: 10,
      //全体の大きさ
      row: r,
      col: c,
      width: a_width + b_width * r, //全体の横幅
      height: b_height * c, //全体の縦幅
      //1個
      width_base: b_width, //横幅
      height_base: b_height, //縦幅
      //各箱
      area: [[], [], [], [], []], //5行
      hold: { i: 0, j: 0 }, //ホールド中の箱
      //1箱の基本情報
      box: {
        objWidth: 180, //横幅
        objHeight: 30, //縦幅
        x: 10, //左上を基準とした初期位置
        y: 10, //
        dragging: false, //ドラッグ状態
        color: "black",
        data: {},
        //oepnボタンのサイズ
        open: { text_w: 77, text_h: 22.5, margin: 7 },
      },
      //移動判定要マウス位置
      mouseX: 0,
      mouseY: 0,
      clickTime: 0,
    };
  },
  //-----------------------------------------------------------------
  mounted() {
    this.init(); //初期化
  },
  watch: {},
  //-----------------------------------------------------------------
  methods: {
    //初期化
    init() {
      //camvas要素の取得
      this.SetCanvas();
      //箱を用意
      for (let i = 0; i < this.row; i++) {
        for (let j = 0; j < this.col; j++) {
          //console.log(this.data[j])
          this.area[i].push(Object.assign({}, this.box));
          this.newBox(i, j);
        }
      }
      this.draw(); //描画
    },
    newBox(i, j) {
      this.area[i][j].x = this.box.x + this.width_base * i;
      this.area[i][j].y = this.box.y + this.height_base * j;
      this.area[i][j].color = "white";
      this.area[i][j].data.form_id = 0;
      this.area[i][j].data.label = "null";
      this.area[i][j].data.type = 0;
    },
    load(area) {
      for (let i = 0; i < area.length; i++) {
        if (i >= this.area.length) {
          this.area.push([]);
        }
        for (let j = 0; j < area[i].length; j++) {
          if (this.area[i].length <= j) {
            this.area[i].push(Object.assign({}, this.box));
            this.area[i][j].data = area[i][j];
          } else {
            this.area[i][j].data = area[i][j];
          }
        }
      }
      this.draw();
    },
    //-----------------------------------------------------------------
    //描画関連
    draw() {
      this.SetCanvas();
      this.ctx.clearRect(0, 0, this.width, this.height); //初期化
      this.Lattice(); //マス目の描画
      //this.Box(this.box); //四角の描画
      //this.Circle(this.radius); //円の描画
      //this.Text("Test", 50, 50); //テキストの描画
      //各箱の描画
      for (let i = 0; i < this.row; i++) {
        for (let j = 0; j < this.col; j++) {
          //色の変更
          this.area[i][j].color = this.getFormTypeToColor(this.area[i][j].data);
          //箱の描画
          this.Box(this.area[i][j]);
        }
      }
    },
    //四角の描画
    Box(box) {
      //描画位置 横,縦,横幅,縦幅
      this.ctx.beginPath();
      //色指定
      this.ctx.fillStyle = box.color; //塗りつぶし色
      this.ctx.strokeStyle = "black"; //枠線の色
      //塗りつぶし
      this.ctx.fillRect(
        box.x + this.a_width,
        box.y,
        box.objWidth,
        box.objHeight
      );
      //枠線を書く
      this.ctx.strokeRect(
        box.x + this.a_width,
        box.y,
        box.objWidth,
        box.objHeight
      );
      //form_idの描画
      //this.Text("ID:", box.x + this.a_width + 10, box.y + 22.5);
      this.Text(
        String(box.data.form_id),
        box.x + this.a_width + 10,
        box.y + 22.5
      );
      //formの名前を描画
      this.Text(
        box.data.label,
        box.x + box.open.text_w + this.a_width + 9,
        box.y + box.open.text_h
      );
      //モーダル表示枠
      this.ctx.strokeRect(
        box.x + box.open.text_w + this.a_width + 6,
        box.y + box.open.margin,
        75,
        20
      );
    },
    //円の描画
    Circle(radius) {
      this.ctx.beginPath();
      this.ctx.arc(100, 100, radius, 0, Math.PI * 2);
      this.ctx.fill(); //塗りつぶし
    },
    //マス目の描画
    Lattice() {
      this.ctx.beginPath();
      //横線の記入
      for (let i = 0; i < this.height / this.height_base; i++) {
        this.Text(i, 6, i * this.height_base + 34);
        //
        this.ctx.moveTo(0, i * this.height_base); //横位置,縦位置
        this.ctx.lineTo(this.width, i * this.height_base);
      }
      //縦線の記入
      this.ctx.moveTo(this.a_width, 0); //横位置,縦位置
      this.ctx.lineTo(this.a_width, this.height);
      //
      for (let i = this.width_base; i < this.width; i += this.width_base) {
        this.ctx.moveTo(i + this.a_width, 0); //横位置,縦位置
        this.ctx.lineTo(i + this.a_width, this.height);
      }
      this.ctx.closePath(); //
      this.ctx.stroke();
    },
    //テキスト欄
    Text(str, w, h) {
      this.ctx.font = "18px serif";
      this.ctx.strokeText(str, w, h);
    },
    //-----------------------------------------------------------------------------
    //マウス動作関連
    BoxCheck(x, y, i, j) {
      //箱の判定
      let objX = this.area[i][j].x;
      let objY = this.area[i][j].y;
      let objWidth = this.area[i][j].objWidth;
      let objHeight = this.area[i][j].objHeight;
      //箱内か判定
      if (objX < x && x < objX + objWidth && objY < y && y < objY + objHeight) {
        return true;
      }
      return false;
    },
    ModalOpenCheck(mouseX, MouseY, i, j) {
      //モーダルオープン判定
      let left = this.area[i][j].x + this.area[i][j].open.text_w + 29;
      let right = left + 78;
      let top = this.area[i][j].y + 6;
      let bottom = top + 18;
      if (
        left <= mouseX &&
        mouseX <= right &&
        top <= MouseY &&
        MouseY <= bottom
      ) {
        return true;
      }
      return false;
    },
    //-----------------------------------------------------------------------------
    //マウス動作
    MouseDown(e) {
      let x = e.offsetX;
      let y = e.offsetY;
      //boxの位置情報を取得
      for (let i = 0; i < this.row; i++) {
        for (let j = 0; j < this.col; j++) {
          //箱内であるか判定
          if (this.BoxCheck(x, y, i, j)) {
            this.box.dragging = true;
            this.draw(); //再描画
            this.hold.i = i;
            this.hold.j = j;
            //移動距離の計算用
            this.mouseX = x;
            this.mouseY = y;
            break;
          }
        }
      }
    },
    MouseUp(e) {
      this.box.dragging = false;
      //位置を揃える
      this.area[this.hold.i][this.hold.j].x =
        this.box.x + this.width_base * this.hold.i;
      this.area[this.hold.i][this.hold.j].y =
        this.box.y + this.height_base * this.hold.j;
      //this.ModalOpen()
      this.ModalCheck(e.offsetX, e.offsetY);
      this.draw();
    },
    MouseMove(e) {
      //箱の入れ替え処理
      if (this.box.dragging) {
        //入れ替え判定
        let moveX = e.offsetX - this.mouseX;
        let moveY = e.offsetY - this.mouseY;
        let sizeX = this.width / this.row / 2;
        let sizeY = this.height / this.col / 2;
        //移動
        this.area[this.hold.i][this.hold.j].x = e.offsetX - 21;
        this.area[this.hold.i][this.hold.j].y = e.offsetY - 5;
        //入れ替え
        if (sizeX < moveX && this.hold.i < this.row - 1) {
          //console.log("X right OUT")
          this.changeBox(
            this.hold.i,
            this.hold.j,
            this.hold.i + 1,
            this.hold.j
          );
        }
        if (moveX < -sizeX && 0 < this.hold.i) {
          //console.log("X left OUT")
          this.changeBox(
            this.hold.i,
            this.hold.j,
            this.hold.i - 1,
            this.hold.j
          );
        }
        if (sizeY < moveY && this.hold.j < this.col - 1) {
          //console.log("Y down OUT")
          this.changeBox(
            this.hold.i,
            this.hold.j,
            this.hold.i,
            this.hold.j + 1
          );
        }
        if (moveY < -sizeY && 0 < this.hold.j) {
          //console.log("Y UP OUT")
          this.changeBox(
            this.hold.i,
            this.hold.j,
            this.hold.i,
            this.hold.j - 1
          );
        }
      } else {
        //否ドラッグ時カーソル該当の色を変更
        let MouseX = e.offsetX;
        let MouseY = e.offsetY;
        for (let i = 0; i < this.row; i++) {
          for (let j = 0; j < this.col; j++) {
            this.area[i][j].data.focus = null;
            if (this.BoxCheck(MouseX, MouseY, i, j)) {
              this.area[i][j].data.focus = "focus";
            }
            if (this.ModalOpenCheck(MouseX, MouseY, i, j)) {
              this.area[i][j].data.focus = "modalFocus";
            }
          }
        }
      }
      this.draw();
    },
    //-------------------------------------------------------------------
    changeBox(i, j, ii, jj) {
      //データの中身を入れ替える
      const tmp = Object.assign({}, this.area[i][j]);
      this.area[i][j] = Object.assign({}, this.area[ii][jj]);
      this.area[ii][jj] = Object.assign({}, tmp);
      //ホールドしているオブジェクトを変える
      this.hold.i = ii;
      this.hold.j = jj;
      //移動距離の計算用
      this.mouseX = this.box.x + this.width_base * ii;
      this.mouseY = this.box.y + this.height_base * jj;
      //位置の入れ替え
      this.area[i][j].x = this.box.x + this.width_base * i;
      this.area[i][j].y = this.box.y + this.height_base * j;
      //
      this.draw();
      this.save();
    },
    //列の追加
    col_add() {
      this.col++;
      this.height = this.height_base * this.col; //全体の縦幅
      for (let i = 0; i < this.row; i++) {
        this.area[i].push(Object.assign({}, this.box));
        this.newBox(i, this.col - 1);
      }
      this.save();
      this.draw();
    },
    //行の追加
    row_add() {
      this.row++;
      this.width = this.width_base * this.row; //全体の縦幅
      this.area.push([]);
      for (let i = 0; i < this.col; i++) {
        this.area[this.row - 1].push(Object.assign({}, this.box));
        this.newBox(this.row - 1, i);
      }
      this.save();
      this.draw();
    },
    //n行目に1列追加
    async insertOneline(target) {
      this.view = false;
      this.col++;
      this.height = this.height_base * this.col; //全体の縦幅
      for (let i = 0; i < this.row; i++) {
        this.area[i].splice(target, 0, Object.assign({}, this.box));
        //x,yの位置変更
        for (let j = target; j < this.col; j++) {
          this.area[i][j].x = this.width_base * i + this.box.x;
          this.area[i][j].y = this.height_base * j + this.box.y;
        }
      }
      this.view = true;
      this.save();
      this.draw();
    },
    //
    SetCanvas() {
      var canvas = document.getElementById("canvassample");
      this.ctx = canvas.getContext("2d");
      canvas.setAttribute("width", this.width.toString());
      canvas.setAttribute("height", this.height.toString());
    },
    ModalCheck(x, y) {
      for (let i = 0; i < this.row; i++) {
        for (let j = 0; j < this.col; j++) {
          if (this.ModalOpenCheck(x, y, i, j)) {
            this.ModalOpen(i, j);
            return;
          }
        }
      }
    },
    ModalOpen(i, j) {
      //親コンポーネントのメソッドを実行
      this.$emit("clickSubmit", this.area[i][j].data, i, j);
    },
    save() {
      //this.area からデータのみの配列を作る
      let area = [];
      for (let i = 0; i < this.area.length; i++) {
        area.push(new Array());
        for (let j = 0; j < this.area[i].length; j++) {
          area[i].push(Object.assign({}, this.area[i][j].data));
        }
      }
      this.$emit("clickSubmit2", area); //データの更新
    },
    //
    formCopy() {
      this.$emit("formCopy");
    },
    formCopyRow() {
      this.$emit("formCopyRow");
    },
    del() {
      this.$emit("clickDelete");
    },
    //
    takeover() {
      this.$emit("clickTakeover");
    },
    getFormTypeToColor(data) {
      let str = "white";
      if (data.focus == "focus") {
        return "#00bfff";
      }
      if (data.focus == "modalFocus") {
        return "#e6e6fa";
      }
      switch (data.type) {
        case 0:
          break;
        case 1: //テキスト
          return "#a0d8ef";
        case 2: //セレクトボックス
          return "lemonchiffon";
        case 3: //日付
          return "#86E1E3";
        case 7: //ラジオボタン
          return "#009688";
        case 14: //チェックボックス
          return "#AFB42B";
        case 15: //時刻
          return "#E88066";
        case 16: //ボタン
          return "lightcoral";
        case 17: //サブページ
          return "aquamarine";
        case 18: //ユーザ情報
          return "#E65100";
        case 20: //送信ボタンオプション
          return "#eebbc3";
        case 22: //削除ボタンオプション
          return "#b8c1ec";
        case 24: //div 表示・非表示切り替えフォーム
          return "orange";
        case 37: //マスタ取得/格納フォーム
          return "#A1887F";
        default:
          return "#FFF3E0";
      }
      return str;
    },
  },
};
</script>
<style scoped>
.scroll {
  overflow: scroll;
}
.canvas {
  border: 1px solid rgb(133, 37, 37);
  background-color: #dddd;
}
</style>
